import { functions } from '../lib/firebase';
import { httpsCallable } from 'firebase/functions';

export interface SemanticSearchResponse {
    results: any[];
}

export const searchSemantic = async (query: string, limit: number = 20): Promise<SemanticSearchResponse> => {
    const searchFn = httpsCallable<{ query: string; limit?: number }, SemanticSearchResponse>(functions, 'searchSemantic');
    const result = await searchFn({ query, limit });
    return result.data;
};
